import { useMediaQuery } from '@mui/material';

export const TOUCH_DEVICE_MEDIA_QUERY = '(hover: none) and (pointer: coarse)';

export const useIsTouchDevice = () => useMediaQuery(TOUCH_DEVICE_MEDIA_QUERY);
